import { render, staticRenderFns } from "./WidgetCategoryReviewsGalleryPc.vue?vue&type=template&id=6bfbadca"
import script from "./WidgetCategoryReviewsGalleryPc.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsGalleryPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports